import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="countqueuingstrategy" id="countqueuingstrategy"></a>
    <h1 {...{
      "id": "windowcountqueuingstrategy"
    }}>{`window.CountQueuingStrategy`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CountQueuingStrategy"
      }}>{`Web APIs - CountQueuingStrategy`}</a>{`  `}</p>
    <a name="new-countqueuingstrategy-new" id="new-countqueuingstrategy-new"></a>
    <h2 {...{
      "id": "countqueuingstrategyinit"
    }}>{`CountQueuingStrategy(init)`}</h2>
    <p>{`Creates a new CountQueuingStrategy object with the provided high water mark.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`CountQueuingStrategy`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`init`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Object with high water mark property.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`init.highWaterMark`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The total number of chunks that can be contained in the internal queue before backpressure is applied.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="countqueuingstrategy-highwatermark" id="countqueuingstrategy-highwatermark"></a>
    <h2 {...{
      "id": "highwatermark--number"
    }}>{`highWaterMark : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The high water mark.`}</p>
    <a name="countqueuingstrategy-size" id="countqueuingstrategy-size"></a>
    <h2 {...{
      "id": "size"
    }}>{`size()`}</h2>
    <p>{`The size of chunk, always 1.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      